import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Spinner Message",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-spinner-message",
    args: {
        message: "Loading this content may takes up to 60 seconds.",
        opened: "false",
    },
    argTypes: {
        message: {
            control: "text",
        },
        opened: {
            control: "boolean",
        },
    },
};

const Template = ({ message, opened }) =>
    html`<ux-iws-spinner-message
        message="${message}"
        opened="${opened}"
    ></ux-iws-spinner-message>`;

export const Default = Template.bind({});
